// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__19owv","text":"Spinner_text__1j8X0"};